import Chip from '@mui/material/Chip';

export const normalizeBookingStatus = (status) =>
  (status ?? 'pending').toString().trim().toLowerCase().replace(/\s+/g, '');

const BOOKING_STATUS_COLORS = {
  pending: 'warning',
  confirmed: 'success',
  cancelled: 'error',
  canceled: 'error',
  completed: 'info',
  inprogress: 'primary',
  processing: 'primary',
  refunded: 'default',
};

export const getBookingStatusColor = (status) =>
  BOOKING_STATUS_COLORS[normalizeBookingStatus(status)] ?? 'default';

export const formatBookingStatusLabel = (status) => {
  if (!status) return 'Pending';
  const s = status.toString().trim();
  if (/^[A-Z]/.test(s) && s.includes(' ')) return s;
  return s
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, (c) => c.toUpperCase());
};

export function BookingStatusChip({ status, size = 'small', ...chipProps }) {
  return (
    <Chip
      label={formatBookingStatusLabel(status)}
      color={getBookingStatusColor(status)}
      size={size}
      {...chipProps}
    />
  );
}
